import { matchRoutes, RouteObject } from 'react-router-dom';

import { vendorRoutes } from '@/router/vendorRoutes';
import { VendorRouteId } from '@/types';

export const getMatchedRoute = <T extends RouteObject = RouteObject>(
	routes: T[],
	path?: string,
) => {
	const { pathname } = window.location;
	return matchRoutes(routes, path ?? pathname)?.pop();
};

export const isVendorRoute = () => {
	const matchedRoute = getMatchedRoute(vendorRoutes);
	if (matchedRoute?.route?.id) {
		return Object.values(VendorRouteId).includes(matchedRoute.route.id);
	}
	return false;
};
